<div
    class="avi-main-header-controller-site-selector"
    *ngIf="hasControllerSites && selectedControllerSiteRef"
>
    <cds-divider
        orientation="vertical"
        class="avi-main-header-controller-site-selector__divider"
    ></cds-divider>
    <avi-collection-dropdown
        class="avi-main-header-controller-site-selector__dropdown sel-avi-main-header-controller-site-selector-dropdown"
        [collection]="controllerSiteCollection"
        [(ngModel)]="selectedControllerSiteRef"
        (ngModelChange)="handleControllerSiteChange($event)"
        [selectedValuesTemplateRef]="selectedValuesTemplateRef"
        [disableCreate]="true"
        [disableEdit]="true"
        [required]="true"
        [preventLoad]="true"
    ></avi-collection-dropdown>
    <ng-template #selectedValuesTemplateRef>
        <label
            class="avi-main-header-controller-site-selector__controller-label"
            for="avi-main-header-controller-site-selector-selected-controller-site"
        >
            {{ globalL10nKeys.controllerLabel | vtranslate }}
        </label>
        <div
            class="avi-main-header-controller-site-selector__controller-site"
            id="avi-main-header-controller-site-selector-selected-controller-site"
        >
            {{ (selectedControllerSiteRef | name) || selectedControllerSiteRef }}
        </div>
    </ng-template>
</div>
